import { takeLatest, call, put } from 'redux-saga/effects';
import * as http from './http';
import { setLoading, clearState, setRoutes, setError } from './duck';

// @effect Action
const listMounted$ = 'journeyHistoricalRoutes/listMounted$';
const listUnmounted$ = 'journeyHistoricalRoutes/listUnmounted$';

// @effect Creators
export const listMounted = (params) => ({
  type: listMounted$,
  payload: { params },
});

export const listUnmounted = () => ({
  type: listUnmounted$,
  payload: {},
});

function* handleDataRequest(params) {
  yield put(setLoading(true));
  try {
    const response = yield call(http.getRoutes, params);
    yield put(setRoutes(response.data));
  } catch (e) {
    console.error('LH getHistoricalRoutes error:', e);
    yield put(setError(e));
  } finally {
    yield put(setLoading(false));
  }
}

function* handleListMounted({ payload }) {
  const { params } = payload;
  yield call(handleDataRequest, params);
}

function* handleListUnmounted() {
  yield put(clearState());
}

// Watchers
export function* watchJourneyHistoricalRoutes() {
  yield takeLatest(listMounted$, handleListMounted);
  yield takeLatest(listUnmounted$, handleListUnmounted);
}
